//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    cols: {
      type: Number,
      default: 1
    }
  }
}
